import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.timers.js";
import { MouseMoveActions } from './MouseMoveActions';
import { GetScrollLeftValueForTabContainer } from './GetScrollLeftValueForTabContainer';
import { CalculateTabsValues } from './CalculateTabsValues';
import { SetActiveTab } from './SetActiveTab';
import { ScrollToProperSection } from './ScrollToProperSection';
import { ListenerType, TabContainerStickyClassActions, TabsState, WindowEvents } from './types';
import { TAB_CONTAINER_STICKY_CLASS, TAB_CONTAINER_STUCK_CLASS } from './constants';
import { gtmPushEvent } from '~/helpers/gtm';
var scrollDebounceTimer = null;
export var TabsMethods = function TabsMethods(tabsData) {
  var _MouseMoveActions = MouseMoveActions(tabsData),
    tabContainerRefListeners = _MouseMoveActions.tabContainerRefListeners,
    isScrolling = _MouseMoveActions.isScrolling;
  var _CalculateTabsValues = CalculateTabsValues(tabsData),
    changeTabContainerStickyClass = _CalculateTabsValues.changeTabContainerStickyClass,
    setTabSectionsProperWidth = _CalculateTabsValues.setTabSectionsProperWidth,
    statePosition = _CalculateTabsValues.statePosition;
  var scrollToSection = ScrollToProperSection(tabsData).scroll;
  var setActiveTab = SetActiveTab(tabsData).set;
  var route = useRoute();
  var stickyTabContainerScrollHandler = function stickyTabContainerScrollHandler() {
    var positionState = _defineProperty(_defineProperty(_defineProperty({}, TabsState.base, function () {
      changeTabContainerStickyClass(TabContainerStickyClassActions.remove, TAB_CONTAINER_STICKY_CLASS);
    }), TabsState.sticky, function () {
      changeTabContainerStickyClass(TabContainerStickyClassActions.remove, TAB_CONTAINER_STUCK_CLASS);
      changeTabContainerStickyClass(TabContainerStickyClassActions.add, TAB_CONTAINER_STICKY_CLASS);
      setTabSectionsProperWidth();
    }), TabsState.stuck, function () {
      changeTabContainerStickyClass(TabContainerStickyClassActions.remove, TAB_CONTAINER_STICKY_CLASS);
      changeTabContainerStickyClass(TabContainerStickyClassActions.add, TAB_CONTAINER_STUCK_CLASS);
    });
    positionState[statePosition()]();
  };
  var url = route.fullPath;
  var scrollToProperSection = function scrollToProperSection(sectionID) {
    if (isScrolling) return;
    scrollToSection(sectionID);
    gtmPushEvent('anchor', {
      event: 'generic_event',
      event_category: 'engagement',
      event_action: 'click',
      page_url: url,
      event_name: 'generic_event',
      anchor: sectionID
    });
  };
  var scrollToProperTabInTabsContainer = function scrollToProperTabInTabsContainer() {
    if (isScrolling || !(tabsData !== null && tabsData !== void 0 && tabsData.tabContainerRef)) return;
    tabsData.tabContainerRef.scrollLeft = GetScrollLeftValueForTabContainer(tabsData);
  };
  var onScrollHandler = function onScrollHandler() {
    if (isScrolling) return;
    if (scrollDebounceTimer != null) {
      clearTimeout(scrollDebounceTimer);
    }
    scrollDebounceTimer = setTimeout(function () {
      scrollToProperTabInTabsContainer();
    }, 50);
    tabsData.currentActiveTab = setActiveTab();
  };
  var getLastElement = function getLastElement() {
    var _tabsData$tabs, _tabsData$tabs$fields;
    var lastTabContents = (_tabsData$tabs = tabsData.tabs[tabsData.tabs.length - 1]) === null || _tabsData$tabs === void 0 ? void 0 : (_tabsData$tabs$fields = _tabsData$tabs.fields) === null || _tabsData$tabs$fields === void 0 ? void 0 : _tabsData$tabs$fields.contents;
    return lastTabContents ? lastTabContents[lastTabContents.length - 1] : null;
  };
  var windowListeners = [{
    key: WindowEvents.scroll,
    func: onScrollHandler,
    type: ListenerType.window
  }, {
    key: WindowEvents.scroll,
    func: stickyTabContainerScrollHandler,
    type: ListenerType.window
  }, {
    key: WindowEvents.resize,
    func: setTabSectionsProperWidth,
    type: ListenerType.window
  }];
  var listeners = [].concat(windowListeners, _toConsumableArray(tabContainerRefListeners));
  var handleListeners = function handleListeners(listenerAction) {
    listeners.forEach(function (listener) {
      var element = listener.type == ListenerType.window ? window : tabsData.tabContainerRef;
      element["".concat(listenerAction, "EventListener")](listener.key, listener.func);
    });
  };
  return {
    setTabSectionsProperWidth: setTabSectionsProperWidth,
    stickyTabContainerScrollHandler: stickyTabContainerScrollHandler,
    setActiveTab: setActiveTab,
    scrollToProperSection: scrollToProperSection,
    onScrollHandler: onScrollHandler,
    lastTabContentsLastElement: getLastElement(),
    handleListeners: handleListeners
  };
};